<!-- 文本配置 -->
<template>
  <div
    class="text-setting"
    :style="{
      background:data.backgroundColor,
      'margin-bottom': (data.marginBottom) / 16 + 'rem',
      'margin-left': (data.marginLeft) / 16 + 'rem',
      fontSize: (data.fontSize) / 16 + 'rem',
      fontWeight:data.fontWeight,
      color:data.titleColor,
      textAlign:data.textAlign,
      lineHeight: (data.lineHeight) / 16 + 'rem',
      fontFamily:data.family
    }"
  >{{ data.title }}</div>
</template>

<script>
export default {
  name: "PageSetting",
  props: {
    data: {
      type: Object,
      default: () => { return {} }
    }
  },
}
</script>

<style lang="less" scoped>
  .text-setting {
    overflow: hidden;
    border-radius: 5px;
    padding: 0 10px;
    word-break: break-all;
    white-space: pre-line;
  }
</style>
